export { Heading, type HeadingProps } from './styled/heading'
